import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from "mobx-react"
import { TableNameAvatarCell, StatsPreview, DotLoader } from '@myplay/ui';

import getAgeFromDate from '../../utils/getAgeFromDate';
import { TableIconsCell } from '..';
import { GREEN_LIGHT } from '../../styles/colors';
import { toTitleCase } from '../../utils/stringManipulations';
import I18N from '../../I18N';
import "./ClubAthletesTableItem.scss";

const ClubAthletesTableItem = ({ TeamsStore, athlete, onDelete, isSelected }) => {
  const { lastName, firstName, avatar, category, teamName, birthdate, highlightsCount, avatarBgColor, _id, teams, playerNumbersPerTeam, playerNumber } = athlete;
  const age = getAgeFromDate(birthdate);
  const [clubRelatedTeams, setClubRelatedTeams] = useState([]);
  const [selectedPlayerStats, setSelectedPlayerStats] = useState(null);

  const getDisplayedTeamName = () => {
    const relatedTeams = TeamsStore.teams.filter(team => teams.includes(team._id));
    setClubRelatedTeams(relatedTeams)
  }
  useEffect(() => {
    getDisplayedTeamName();
  }, []);

  useEffect(() => {
    if (isSelected) {
      getPlayerStats();
    }
  }, [isSelected]);

  const getPlayerStats = async (teamId = null) => {
    const { getPlayerStats } = TeamsStore;
    setSelectedPlayerStats(null);
    const stats = await getPlayerStats(_id, teamId || athlete.teams[0]);
    setSelectedPlayerStats(stats);
  }

  return (
    <Fragment>
      <Fragment>
        <TableNameAvatarCell firstName={firstName} lastName={lastName} avatar={avatar} avatarBgColor={avatarBgColor} />
        <span className="club-athletes-table-item__jersey">{playerNumbersPerTeam ? playerNumbersPerTeam[teams[teams.length - 1]] : playerNumber}</span>
        <span className="club-athletes-table-item--white">
          {teamName}
          {clubRelatedTeams.length > 1 &&
            <span style={{ color: GREEN_LIGHT }}>{` (+${teams.length - 1}) `}</span>
          }
        </span>
        <span className="club-athletes-table-item--white">{category}</span>
        <span className="club-athletes-table-item--white">{age}</span>
        <span className="club-athletes-table-item--white">{highlightsCount || 0}</span>
        <div className="club-athletes-table-item__icons-container">
          <TableIconsCell onDeleteClick={onDelete} />
        </div>
      </Fragment>
      {isSelected &&
        <Fragment>
          {clubRelatedTeams.map((team, i) => {
            if (i < clubRelatedTeams.length - 1) {
              return (
                <Fragment>
                  <span style={{ gridColumnStart: 2, color: GREEN_LIGHT }}>{playerNumbersPerTeam && playerNumbersPerTeam[team._id] || ''}</span>
                  <button className="club-athletes-table-item__team" onClick={() => getPlayerStats(team._id)}>
                    <span style={{ gridColumnStart: 3 }}>{team.name}</span>
                  </button>
                </Fragment>
              );
            }
          })}
        </Fragment>
      }
      {isSelected &&
        <div className="club-athletes-table-item__stats-preview-wrapper" style={{ maxHeight: !selectedPlayerStats ? "400px" : "400px" }}>
          {selectedPlayerStats ?
            <Fragment>
              <span className="club-athletes-table-item__stats-preview-wrapper__headline">{toTitleCase(I18N.t("SEASONAL_AVERAGE"))}</span>
              <StatsPreview bars={selectedPlayerStats.bars} donuts={selectedPlayerStats.donuts} isPlayerProfile />
            </Fragment> :
            <DotLoader />
          }
        </div>
      }
    </Fragment>
  );
};

ClubAthletesTableItem.propTypes = {
  athlete: PropTypes.object,
  onDelete: PropTypes.func,
};

ClubAthletesTableItem.defaultProps = {
  athlete: {},
  onDelete: () => { }
};

export default inject("TeamsStore")(observer(ClubAthletesTableItem));